import { DataSource } from "src/app/_Models/common/common.model";

export const PageSizeCommon = [10, 25, 50, 100];
export const NewOption: number = -11; //NEW option in dropdownlist. it skip validation.
export const ListSize: number = 10;
export const UtilizationChartMinValue: number = 0;
export const UtilizationChartMaxValue: number = 100;
export const CusDashboardProductNameTrim: number = 17;
export const CusDashboardProductLength: number = 5;
export const QuotationSummaryNameLength: number = 53;
export const QuotationSummaryNameFirstLineLength: number = 25;
export const ServiceDateLength: number = 22;
export const FBResultNAName: string = "N/A";
export const FBResultNotApplicableName: string = "Not Applicable";
export const MobileViewFilterCount: number = 1;
export const MobileViewFiltersCount: number = 2;
export const CountrySelectedFilterTextCount: number = 3;
export const SupplierNameTrim: number = 28;
export const CustomerContact: string = "Customer Contact";
export const SupplierContact: string = "Supplier Contact";
export const FactoryContact: string = "Factory Contact";
export const DefectDashboardCountryTextCount: number = 3;
export const DefectDashboardSupplierNameTrim: number = 28;
export const DefectDashboardDataLengthTrim: number = 5;
export const amCoreLicense = "CH238479116";
export const DefectDashboardParetoNameTrim: number = 18;
export const DashboardCountryDefectNameTrim: number = 14;
export const DashboardDefectNamecPopupTrim: number = 19;
export const QuantitativeDashboardProductLength: number = 4;
export const QuantitativeDashboardCountryNameTrim: number = 9;
export const NumberOne = 1;
export const DecMonth = 12;
export const YearCount = 2;
export const ZeroValue = 0;
export const ListLengthOne = 1;
export const ListLengthTwo = 2;
export const ListLengthThree = 3;
export const CSDashboardStatusTrimValue: number = 7;
export const CSDashboardOfficeTrimValue: number = 11;
export const CSDashboardServiceTypeTrimValue: number = 14;

export const CSDashboardBookingVerified: string = "verified";
export const CSDashboardBookingConfirmed: string = "confirmed";
export const CSDashboardCreated: string = "created";
export const CSDashboardQuotationSent: string = "sent";
export const CSDashboardCustomerConfirmed: string = "validated";
export const CSDashboardQuotationApproved: string = "approved";
export const CSDashboardQuotationModify: string = "modify";

//below are the DB id
export const ReportSendInEmailAttachment: number = 2;
export const EmailType: number = 1; //customer decision
export const EmailTypeReportSend: number = 2;
export const EmailSendToOrCCAPITeam: number = 4;
export const EmailSendToOrCCCustomer: number = 1;
export const EmailSendToOrCCSupplier: number = 2;
export const EmailSendToOrCCFactory: number = 3;
export const EmailSendToOrCCMerchandiser: number = 5;

export const BookingSummaryNameTrim: number = 20;

export class EntPageFieldAccess {
  entPageFieldAccessEnum: EntPageFieldAccessEnum;
  name: string;
  isDisplay: boolean;
}

export enum EntPageFieldAccessEnum {
  Booking_Edit_POQuantity = 1,
  Booking_Edit_DisplayMaster = 2,
  Booking_Edit_DisplayChild = 3,
  Booking_Edit_EcoPack = 4,
  Booking_Edit_CustomerRefPo = 5,
  Customer_Product_SubCategory2 = 6,
  Booking_Edit_Product_SubCategory2 = 7,
  Booking_Edit_Picking = 8,
  Booking_Edit_Combine = 9,
  Booking_Edit_Product_Barcode = 10,
  Booking_Edit_Product_Factory_Reference = 11,
  Booking_Edit_First_Service_Date = 12,
  Schedule_Summary_Product_Ref = 13,
  Booking_Edit_TF_Received_Date = 14,
  Booking_Edit_AS_Received_Date = 15,
  Booking_CombineOrder = 16,
}

/* export const EntPageFieldAccessList: Array<any> = [
  { "entPageFieldAccessEnum": EntPageFieldAccessEnum.ProductDescription,"name": }
]; */

export enum UserType {
  InternalUser = 1,
  Customer = 2,
  Supplier = 3,
  Factory = 4,
  QCCompany = 5,
  //Admin=6,
  Vender = 7,
  Laboratory = 6,
  Agent = 8,
}

export enum customer {
  Next = 1593
}

export enum UserTypeForCustomerDecision {
  InternalUser = 1,
  Customer = 2,
  Supplier = 3,
  Factory = 4,
  QCCompany = 5,
}

export enum AuditStatus {
  Requested = 1,
  Confirmed = 2,
  Cancel = 4,
  Rescheduled = 3,
  Scheduled = 5,
  Audited = 6,
}
export enum APIService {
  Inspection = 1,
  Audit = 2,
  Tcf = 3,
  LabTesting = 4,
}

export enum EntityAccess {
  API = 1,
  SGT = 2,
  AQF = 3,
}

export enum APIServiceEnum {
  Audit = 1,
  Inspection = 2,
  TCF = 3,
  LabTesting = 4,
}
export enum BookingStatus {
  New = 0,
  Requested = 1,
  Confirmed = 2,
  Rescheduled = 3,
  Cancel = 4,
  Scheduled = 5,
  Inspected = 6,
  Validated = 7,
  Verified = 8,
  AllocateQC = 9,
  Hold = 10,
  ReportSent = 11,
}
export enum LabBookingStatus {
  New = 1,
  Booked = 2,
  SampleShipped = 3,
  SampleReceived = 4,
  TestInProgress = 5,
  ReportReady = 6,
  Cancelled = 7,
  ReportInvalidated = 8,
}
export enum LabOverAllResult {
  Pass = 1,
  Fail = 2,
  Pending = 3,
}
export enum FeePayBay {
  Supplier = 1,
  Customer = 2,
}
export enum ReportDeleveryType {
  Regular = 1,
  Express = 2,
  Emergency = 3,
}
export const disableInspectionResponsibleStatusList = [
  BookingStatus.Confirmed,
  BookingStatus.Scheduled,
  BookingStatus.Cancel,
  BookingStatus.Inspected,
];

export enum FetchFBReportOption {
  NotValidated = 1,
  All = 2,
}

export enum SearchType {
  BookingNo = 1,
  ReportNo = 2,
  PoNo = 3,
  ServiceDate = 4,
  ApplyDate = 5,
  CustomerBookingNo = 8,
  FirstServiceDate = 9,
  InvoiceNo = 10,
  InvoiceDate = 11,
  ComplaintDate = 12,
  SupplierName = 13,
  SupplierCode = 14,
  ClaimDate = 15,
  ClaimNo = 16,
  ProductId = 17,
}
export enum DefaultDateType {
  ServiceDate = 4,
  ComplaintDate = 12,
  ReceptionDate = 18,
  ApplyDate = 5,
}
export enum DefaultUserType {
  CS = 2,
}
export enum AdvanceSearchType {
  FactoryReference = 6,
  ProductName = 7,
}
export enum AuditSearchRedirectPage {
  Edit = 1,
  Cancel = 2,
  Reschedule = 3,
  Report = 4,
  Schedule_Auditor = 5,
}

export enum BookingSearchRedirectPage {
  Edit = 1,
  Cancel = 2,
  Reschedule = 3,
  Report = 4,
  Schedule = 5,
  CombineProduct = 6,
  SplitBooking = 7,
  ReInspectionBooking = 8,
  ReBooking = 9,
  Quotation = 10,
  ViewBookingForQuotation = 11,
}
export enum LabType {
  Lab = 1,
  Customer = 2,
}
export enum Unit {
  Set = 1,
  Pcs = 4,
}
export enum InspectionPageType {
  Boooking = 1,
  ReInspection = 2,
  ReBooking = 3,
  Quotation = 4,
}
export enum InspPageType {
  ReInspection = 1,
  ReBoooking = 2,
}
export enum Service {
  Inspection = 1,
  Audit = 2,
}
export enum RightsEnum {
  BookingEdit = 1,
  CustomerProduct = 2,
  ScheduleSummary = 3,
}
export enum Currency {
  USD = 156,
}
export enum DynamicControlModuleType {
  InspectionBooking = 1,
  AuditBooking = 2,
}
export enum ControlType {
  TextBox = 1,
  TextArea = 2,
  DropDown = 3,
  DatePicker = 4,
}
export enum ControlAttribute {
  PlaceHolder = 1,
  Type = 2,
  MaxLength = 3,
  MinLength = 4,
  Disabled = 5,
  ReadOnly = 6,
  RequiredValidation = 7,
  EmailValidation = 8,
  Multiple = 9,
  IsCascading = 10,
  ParentDropDown = 11,
}
export const searchtypelst = [
  { name: "Booking No", id: 1, shortName: "AU#" },
  { name: "Report Title No. ", id: 15, shortName: "RN#" },
  { name: "Customer Booking No", id: 8, shortName: "CU#" },
  //{ name: "PO No", id: 3 },
];

export const datetypelst = [
  // { name: "Service Date", id: 4, shortName: "SD" },
  // { name: "Apply date", id: 5, shortName: "AD" },
  // { name: "First Service Date", id: 9, shortName: "FSD" }
  { name: "Service Date", id: 4 },
  { name: "Apply date", id: 5 },
  // { name: "First Service Date", id: 9 }
];

export const datetypelstForQuotation = [{ name: "Service Date", id: 4 }];

export const staffUserTypes = [
  {
    name: "Customer Service",
    id: 2,
  },
  {
    name: "Report Checker",
    id: 11,
  },
];
export enum datetypes {
  FirstserviceDate = 9,
}

export enum InspectionLocationEnum {
  Factory = 1,
  PlatForm = 2,
}

export const scheduleDatetypelst = [
  { name: "Service Date", id: 4 },
  { name: "First Service Date", id: 9 },
];

export const emailSendSummaryDatetypelst = [{ name: "Service Date", id: 4 }];

export const tcfDatetypelst = [
  { name: "ETD Date", id: 7 },
  { name: "Expected Closing date", id: 8 },
  { name: "Expiry Date", id: 9 },
  { name: "Request Date", id: 10 },
];

//Advance Filter in Booking Summary
export const bookingAdvanceSearchtypelst = [
  { name: "Factory Ref", id: 6 },
  { name: "Bar Code", id: 10 },
];
export const cancelrescheduletime = [
  { name: "Less than 24 hours", id: 1 },
  { name: "More than 24 hours", id: 2 },
];

export const usertypelst = [
  { name: "Internal User", id: 1 },
  { name: "Customer", id: 2 },
  { name: "Supplier", id: 3 },
  { name: "Factory", id: 4 },
  { name: "OutSource", id: 5 },
];

export const expenseEmployeeTypeList = [
  { name: "Internal User", id: 1 },
  { name: "OutSource", id: 2 },
];

export const supplier = [
  { name: "Operations", id: 1 },
  { name: "Accounting", id: 2 },
  { name: "Management", id: 3 },
  { name: "QC Manager", id: 4 },
  { name: "Merchandiser", id: 5 },
  { name: "BD Manager", id: 6 },
  { name: "QC", id: 7 },
  { name: "Report Cheker", id: 8 },
];

export const bookingSearchtypelst = [
  { name: "Inspection No", id: 1, shortName: "IN#" },
  { name: "PO No", id: 3, shortName: "PO#" },
  { name: "Customer Booking No.", id: 8, shortName: "CU#" },
  { name: "Product Reference No.", id: 17, shortName: "PR#" },
];

export const tcfSearchtypelst = [
  { name: "Barcode", id: 1 },
  { name: "Customer Reference", id: 2 },
  { name: "Po No", id: 3 },
  { name: "TCF No", id: 4 },
  { name: "Supplier Reference", id: 5 },
  { name: "Description", id: 6 },
];

export const extrafeeSearchtypelst = [
  { name: "Booking #", id: 1 },
  { name: "Cus. Booking #", id: 8 },
];
export const customerReportSearchtypelst = [
  {
    name: "Inspection No",
    shortName: "IN",
    id: 1,
    fullName: "Enter Inspection No",
  },
  { name: "Report No", shortName: "RE", id: 2, fullName: "Enter Report No" },
];
/* export const customerReportSearchtypelst = [
  { name: "Inspection No", id: 1 },
  { name: "Report No", id: 2 },
  { name: "Cus. booking#", id: 8 },
]; */
export const claimDatetypelst = [
  { name: "Service Date", id: 4 },
  { name: "Claim date", id: 15 },
];

export const BookingTableScrollHeight: number = 468; // used for condition check to scroll apply
export const QuotationTableScrollHeight: number = 1000; // used for condition check to scroll apply
export const InspCertificatePopupBookingTableScrollHeight: number = 350; // used for condition check to scroll apply
export const InspCertificateProductDeleteCount: number = 1;
export const CombineBookingTableScrollHeight: number = 750; // used for condition check to scroll apply
//  only china we need to filter
export enum Country {
  China = 38,
  Vietnam = 198,
}

// Default status list to check the limit -- here id refered from INSP_Status table
export const bookingStatusList = [
  { name: "Inspected", id: 6 },
  { name: "Validated", id: 7 },
  { name: "ReportSent", id: 11 },
];

//Schedule User Types
export enum ScheduleRole {
  QC = 4,
  AdditionalQC = 4,
  CS = 2,
}

//to check the Header Limit in the Menu
export enum HeaderCount {
  count = 7,
  zeroCount = 0,
}
export const icsearchtypelst = [
  { name: "Inspection No", id: 1 },
  // { name: "PO No", id: 2 },
  { name: "IC No", id: 3 },
];
export enum EmailUserVerication {
  ScheduleQCEmail = 1,
  ReportFilledToReportChecker = 2,
}

export enum HRProfileEnum {
  Auditor = 1,
  CS = 2,
  Quotation = 10,
  Inspector = 4,
  ReportChecker = 11,
}

export enum AqlType {
  AQLI = 1,
  AQLII = 2,
  AQLIII = 3,
  AQLCustom = 8,
}

export enum SampleType {
  Sample1 = 1,
  Sample2 = 2,
  Sample3 = 3,
  Sample5 = 4,
  Sample100 = 5,
  Other = 6,
}

export enum RoleEnum {
  Cs = 1,
  Inspector = 2,
  IT_Team = 4,
  Management = 5, // approver leave and expense (Manager)
  CSManagement = 6,
  ExpenseRoleAccess = 7, //expense finance team
  HumanResource = 10, //leave access
  LeaveHr = 18, // Hr Leave
  ExpenseClaimNotification = 19, // expense claim email access
  QuotationRequest = 20,
  QuotationManager = 21,
  QuotationConfirmation = 22,
  InspectionRequest = 23,
  InspectionConfirmed = 24,
  InspectionVerified = 25,
  InspectionScheduled = 26,
  QuotationSend = 27,
  EditInspectionCustomerDecision = 33,
  ViewInspectionCustomerDecision = 34,
  InspectionCertificate = 32, // issue ic
  ReportChecker = 35,
  Accounting = 12,
  TechnicalTeam = 8,
  OperationTeamManagement = 9,
  HRManagement = 11,
  KAM = 13,
  CEO = 14,
  SalesTeam = 15,
  Supplier = 30,
  Factory = 31,
  TCFSupplier = 39,
  TCFIT = 40,
  WorkLoadMatrix = 44,
  OutSourceAccountingRole = 48,
}
export enum ICStatus {
  Canceled = 2,
}
export class DateObject {
  public year: number;
  public month: number;
  public day: number;
}

export enum EmployeeType {
  Permanent = 1,
  Outsource = 2,
  Other = 3,
}

export enum StaffType {
  Inspector = 1,
  ReportChecker = 2,
}

export enum InspectedStatusList {
  Inspected = 6,
  ReportSent = 11,
  AllocateQC = 9,
  //Validated = 7
}

export enum InspectionServiceType {
  Container = 8,
  FinalRandomInspection = 5,
  FinalRandomReInspection = 15,
  //SgtContainer = 49
}

export const ContainerServiceList = [InspectionServiceType.Container];

export const HRProfileUserConfig = [
  { name: "CS", id: 2 },
  { name: "ReportChecker", id: 11 },
  { name: "Planner", id: 3 },
  { name: "Quotation", id: 10 },
  { name: "Schduler", id: 12 },
  { name: "Finance", id: 5 },
];

export enum BillingMethod {
  ManDay = 1,
  Sampling = 2,
  PieceRate = 3,
  PerIntervention = 4,
}

export enum EntityFeature {
  AutoExpense = 1,
  MandayComplex = 2,
  SamplingComplex = 3,
  PieceRateComplex = 4,
  PerInterventionComplex = 5,
}

export enum InterventionType {
  Range = 1,
  PerStyle = 2,
}

export enum Url {
  CustomerContact = "cuscontactsearch/customer-contact-summary/",
  SupplierEdit = "supplieredit/edit-supplier/",
  EditBooking = "inspedit/edit-booking/",
  EditInvoice = "editinvoice/edit-invoice/",
  UserProfile = "/userprofile/user-profile/",
  EditSchedule = "schedule/schedule-allocation/",
  EditTravelTariff = "edittraveltariff/schedule-allocation/",
  EditClaim = "editClaim/edit-claim/",
  EditExpenseClaim = "expenseclaim/expense-claim/",
  EditDataManagement = "datamanagement/dmedit/",
  ProductEdit = "cusproductedit/edit-customer-product/",
  EditTCFBooking = "tcfBooking/edit-tcf-booking/",
  TCFDetailNew = "tcfdetailnew/tcf-detail-new/",
  TCFSummaryNew = "tcfBookingSummary/tcf-booking-summary/",
}

export enum FileUploadResponseResult {
  Sucess = 1,
  Failure = 2,
  FileSizeExceed = 3,
}

/* export enum FileContainerList {
  Products = 1,
  DevContainer = 2,
  InsepctionBooking = 3,
  Invoice = 4,
  Hr = 5,
  TcfProducts = 6,
  EmailSend = 7,
  Audit = 8,
  Expense = 9,
  Report = 10,
  QuotationPdf = 11,
  DataManagement = 12,
  Claim = 13
} */

/* export enum FileContainerList {
  ApiProducts = 1,
  DevContainer = 2,
  InsepctionBooking = 3,
  ApiInvoice = 4,
  ApiHr = 5,
  TcfProducts = 6,
  EmailSend = 7,
  ApiAudit = 8,
  ApiExpense = 9,
  Report = 10,
  Organization = 11,
  VendorFiles = 12
} */

export enum LogoPathName {
  StandardIcon = 1,
  Professional = 2,
  Enterprise = 3,
  Package4 = 4,
  Package5 = 5,
}

export enum LogoPathList {
  StandardIcon = "assets/images/new-set/standard-icon.png",
  Professional = "assets/images/new-set/professional-icon.png",
  Enterprise = "assets/images/new-set/enterprise-icon.png",
  Package4 = "assets/images/new-set/package-4-icon.png",
  Package5 = "assets/images/new-set/package-5-icon.png",
}

export const logopathlist = [
  { name: "StandardIcon", value: "assets/images/new-set/standard-icon.png" },
  {
    name: "Professional",
    value: "assets/images/new-set/professional-icon.png",
  },
  { name: "Enterprise", value: "assets/images/new-set/enterprise-icon.png" },
  { name: "Package4", value: "assets/images/new-set/package-4-icon.png" },
  { name: "Package5", value: "assets/images/new-set/package-5-icon.png" },
];

export enum FileContainerList {
  Products = 1,
  DevContainer = 2,
  InsepctionBooking = 3,
  Invoice = 4,
  Hr = 5,
  TcfProducts = 6,
  EmailSend = 7,
  Audit = 8,
  Expense = 9,
  Report = 10,
  Organization = 11,
  VendorFiles = 12,
  tcf = 14,
  TCFStandard = 17,
  lab = 18,
  Private = 5001,
  Quotation = 20,

  /* QuotationPdf = 11,
  DataManagement = 12,
  Claim = 13 */
}

export const StandardDateFormat = "dd/MM/yyyy HH:mm:ss";
export const StandardOnlyDateFormat = "dd/MM/yyyy";
export const StandardDatTimeFormat = "dd/MM/yyyy hh:mm:ss a";

export enum PageTypeSummary {
  CustomerReport = 1,
  FullBridge = 2,
  FillingReview = 3,
}

export enum MSChartFileType {
  MSChart = 1,
  Pictures = 2,
}

export enum MSChartFileTypeForPim {
  MSChartExcel = 3,
  MSChartPdf = 4,
  MSChart = 1,
}

export enum BillPaidBy {
  Customer = 1,
  Supplier = 2,
  Factory = 3,
}

export enum SupplierType {
  Factory = 1,
  Supplier = 2,
  InspectionCompany = 3,
  Laboratory = 4,
  Agent = 5,
}

export enum LabReportType {
  Supplier = 1,
  ProductCategory = 2,
}

export const invoiceSearchtypelst = [
  { name: "Booking No", id: 1 },
  { name: "Invoice No", id: 10 },
];

export enum InvoiceStatus {
  Created = 1,
  Modified = 2,
  Approved = 3,
  Cancelled = 4,
}

export const invoicedatetypelst = [
  { name: "Service Date", id: 4 },
  { name: "Invoice Date", id: 11 },
];
export const KPIPPTtypelst = [
  { name: "Service Date", id: 4 },
  //,{ name: "Invoice Date", id: 11 }
];
export const extrafeedatetypelst = [
  { name: "Service Date", id: 4 },
  { name: "Apply Date", id: 5 },
];
export enum InvoicePaymentStatus {
  NotPaid = 1,
}

export enum ExtraFeeStatus {
  Pending = 1,
  Invoiced = 2,
  Cancel = 3,
}

export enum InvoiceType {
  Monthly = 1,
  PreInvoice = 2,
}

export enum CustomerDecisionSaveResponseResult {
  success = 1,
  fail = 2,
  noemailconfiguration = 3,
  noEmailSubjectConfiguration = 4,
  noEmailBodyConfiguration = 5,
  noEmailRecipientsConfiguration = 6,
  multipleRuleFound = 7,
  ICPDFGenerationIssue = 8,
  IcCouldNotSave = 9,
}
export enum FileAttachmentCategory {
  General = 1,
  Gap = 2,
}

//defect dashboard starts
export const DefectNameList = [
  { name: "Critical", id: 1, checked: true },
  { name: "Major", id: 2, checked: true },
  { name: "Minor", id: 3, checked: true },
];

export const LabReportNameList = [
  { name: "Pass", id: 1, checked: true },
  { name: "Fail", id: 2, checked: true },
  { name: "See Data", id: 3, checked: true },
];

export const DefectCritical = "Critical";
export const DefectMajor = "Major";
export const DefectMinor = "Minor";

export const Pass = "Pass";
export const Fail = "Fail";
export const Pending = "Pending";
export const SeeData = "See Data";
export const None = "None";
export const Na = "N/A";

export const DefectCriticalId = 1;
export const DefectMajorId = 2;
export const DefectMinorId = 3;

//defect dashboard ends

export enum FbFetchStatusList {
  Inspected = 6,
  ReportSent = 11,
  AllocateQI = 9,
}

export enum RescheduleReason {
  RequestedByCustomer = 5,
  RequestedBySupplier = 6,
  RequestedByFactory = 7,
}

export const ITSupporEmail: string = "support@fullbridge.io";
export const LBLServiceDesk: string = "Fullbridge IT support";
export const WormsServicePortal: string =
  "https://wormsgroup.atlassian.net/servicedesk/customer/portals";

export enum QuotationStatus {
  Pending = 0,
  Created = 1,
  ManagerApproved = 2,
  ManagerRejected = 3,
  Verified = 4,
  Canceled = 5,
  CustomerRejected = 6,
  CustomerValidated = 7,
  SentToClient = 8,
  AERejected = 9,
}

export const QuotationStatusList = [
  { name: "Pending", id: 0 },
  { name: "Created", id: 1 },
  { name: "Man. Approved", id: 2 },
  { name: "Man. Rejected", id: 3 },
  { name: "Verified", id: 4 },
  { name: "Canceled", id: 5 },
  { name: "Cust. Rejected", id: 6 },
  { name: "Validated", id: 7 },
  { name: "Sent", id: 8 },
  { name: "AE Rejected", id: 9 },
];
// Default FB Report result list
export const fbReportResultList = [
  { name: "Fail", id: 2 },
  { name: "Pending", id: 3 },
];

export enum FbReportResultType {
  Pass = 1,
  Fail = 2,
  Pending = 3,
  Not_Applicable = 4,
  Missing = 5,
  Conformed = 6,
  NotConformed = 7,
  Delay = 8,
  Note = 9,
}

//user for the search type textbox validat,ion in the customer report page
export enum CustomerReportSearchType {
  BookingNo = 1,
  ReportNo = 2,
}

export const CustomerDecisionDdl = [
  { name: "Given", id: 1 },
  { name: "Not Given", id: 2 },
];

export const APIResult = [
  { name: "All", id: 0 },
  { name: "Pass", id: 1 },
  { name: "Fail", id: 2 },
  { name: "Pending", id: 3 },
  { name: "Not_Applicable", id: 4 },
  { name: "Missing", id: 5 },
];

export const InspectedStatusData = [
  { name: "Inspected", id: 6 },
  { name: "ReportSent", id: 11 },
];

export enum FBStatus {
  ReportDraft = 13,
  ReportArchive = 14,
  ReportValidated = 15,
  ReportInValidated = 16,
  ReportFillingValidated = 9,
}
export const HRStaffStatus = [
  { name: "On-job", id: 1, color: "greencolor" },
  { name: "Retired", id: 2, color: "redColor" },
  { name: "Left", id: 3, color: "redColor" },
];

export const complaintsummaryDatetypelst = [
  { name: "Service Date", id: 4 },
  { name: "Apply date", id: 5 },
  { name: "Complaint Date", id: 12 },
];

export const generalComplaintsummaryDatetypelst = [
  { name: "Apply date", id: 5 },
  { name: "Complaint Date", id: 12 },
];

export const complaintAdvanceSearchtypelst = [
  { name: "Product ID", id: 7 },
  { name: "PO No", id: 9 },
];
export enum FBRedirectionType {
  Mission = 1,
  Report = 2,
}
export const dashboardSupplierNameCodeList = [
  { name: "Supplier Name", id: 13 },
  { name: "Code", id: 14 },
];

export const InvoiceStatusSummaryStatusList = [
  { id: 1, name: "Pending" },
  { id: 2, name: "Invoiced" },
];

export const LinkAppServiceList = [
  { id: 1, name: "Inspection" },
  { id: 2, name: "Audit" },
  { id: 3, name: "TCF" },
  { id: 4, name: "Lab Testing" },
];

export const ServiceImageList = [
  {
    serviceId: APIService.Inspection,
    entityId: EntityAccess.API,
    serviceEnabledFileName: "inspection-navigation.svg",
    serviceDisabledFileName: "inspection-navigation-disabled.svg",
  },
  {
    serviceId: APIService.Audit,
    entityId: EntityAccess.API,
    serviceEnabledFileName: "audit-navigation.svg",
    serviceDisabledFileName: "audit-navigation-disabled.svg",
  },
  {
    serviceId: APIService.Tcf,
    entityId: EntityAccess.API,
    serviceEnabledFileName: "tcf-navigation.svg",
    serviceDisabledFileName: "tcf-navigation-disabled.svg",
  },
  {
    serviceId: APIService.LabTesting,
    entityId: EntityAccess.API,
    serviceEnabledFileName: "lab-navigation.svg",
    serviceDisabledFileName: "lab-navigation-disabled.svg",
  },
  {
    serviceId: APIService.Inspection,
    entityId: EntityAccess.SGT,
    serviceEnabledFileName: "inspection-navigation.svg",
    serviceDisabledFileName: "inspection-navigation-disabled.svg",
  },
  {
    serviceId: APIService.Audit,
    entityId: EntityAccess.SGT,
    serviceEnabledFileName: "audit-navigation.svg",
    serviceDisabledFileName: "audit-navigation-disabled.svg",
  },
  {
    serviceId: APIService.Tcf,
    entityId: EntityAccess.SGT,
    serviceEnabledFileName: "tcf-navigation.svg",
    serviceDisabledFileName: "tcf-navigation-disabled.svg",
  },
  {
    serviceId: APIService.LabTesting,
    entityId: EntityAccess.SGT,
    serviceEnabledFileName: "lab-navigation.svg",
    serviceDisabledFileName: "lab-navigation-disabled.svg",
  },
  {
    serviceId: APIService.Inspection,
    entityId: EntityAccess.AQF,
    serviceEnabledFileName: "inspection-navigation.svg",
    serviceDisabledFileName: "inspection-navigation-disabled.svg",
  },
  {
    serviceId: APIService.Audit,
    entityId: EntityAccess.AQF,
    serviceEnabledFileName: "audit-navigation.svg",
    serviceDisabledFileName: "audit-navigation-disabled.svg",
  },
  {
    serviceId: APIService.Tcf,
    entityId: EntityAccess.AQF,
    serviceEnabledFileName: "tcf-navigation.svg",
    serviceDisabledFileName: "tcf-navigation-disabled.svg",
  },
  {
    serviceId: APIService.LabTesting,
    entityId: EntityAccess.AQF,
    serviceEnabledFileName: "lab-navigation.svg",
    serviceDisabledFileName: "lab-navigation-disabled.svg",
  },
];

export const travelMatrixSearchTypeList = [
  { name: "City", id: 1 },
  { name: "County", id: 2 },
];

export enum TravelMatrixSearchEnum {
  City = 1,
  County = 2,
}

export const categorytypelst = [
  { name: "Category", id: 1 },
  { name: "Sub", id: 2 },
  { name: "Sub 2", id: 3 },
  { name: "Sub 3", id: 4 },
];

export const CategoryFilterDdl = [
  { name: "Mapped", id: 1 },
  { name: "Not Mapped", id: 2 },
];

export enum ExpenseTypeEnum {
  OutsourceInspectionFees = 26,
}

export const pendingClaimSearchTypeLst = [
  { name: "Booking No", id: 1 },
  { name: "Claim No", id: 16 },
];

export const MandayCompanyByList = [
  { id: 1, name: "1 Month" },
  { id: 3, name: "3 Month" },
  { id: 6, name: "6 Month" },
  { id: 12, name: "12 Month" },
];

export const MandayDropDown = [
  { id: 1, name: "Estimated Man Day" },
  { id: 2, name: "Actual Man Day" },
];

export enum MandayType {
  EstimatedManDay = 1,
  ActualManDay = 2,
}

export enum GeneralDefaultDateType {
  ApplyDate = 5,
}

export const NotificationList: DataSource[] = [
  { id: 25, name: "Customer Service" },
  { id: 20, name: "Quotation Create" },
  { id: 27, name: "Quotation Send" },
  { id: 22, name: "Quotation Validate" },
  { id: 35, name: "Report Checker" },
];

export const appThemeList = [
  { name: "sgt-theme", id: EntityAccess.SGT },
  { name: "aqf-theme", id: EntityAccess.AQF },
];

export enum theme {
  light = 1,
  dark = 2,
}

export const themeList = [
  { name: "light", id: theme.light },
  { name: "dark", id: theme.dark },
];

export const creditNoteSearchTyplst = [
  { name: "Credit No", id: 1, shortName: "CE#" },
];

export enum InvoicePreviewType {
  Booking = 1,
  Product = 2,
  SimpleInvoice = 3,
  PO = 4,
  InvoiceExtraFee = 5,
  Audit = 6,
  ManualInvoice = 7,
  CreditNote = 8,
}

export enum SaveCustomerResult {
  Success = 1,
  CustomerIsNotSaved = 2,
  CustomerIsNotFound = 3,
  CustomerExists = 4,
  CustomerAddressNotFound = 5,
  DuplicateCustomerNameFound = 6,
  DuplicateGLCodeFound = 7,
  DuplicateEmailFound = 8,
  CustomErrorFound = 9,
  CustomerOneBrandRequired = 10,
  CustomerEntiyNotRemoved = 11,
}

export enum SaveCustomerBuyerResult {
  Success = 1,
  CustomerBuyerIsNotSaved = 2,
  CustomerBuyerIsNotFound = 3,
  CustomerBuyerExists = 4,
}

export enum SaveCustomerDepartmentResult {
  Success = 1,
  CustomerDepartmentIsNotSaved = 2,
  CustomerDepartmentIsNotFound = 3,
  CustomerDepartmentExists = 4,
}

export const reportSearchTypeLst = [
  { name: "Inspection No", id: 1, shortName: "IN#" },
  { name: "PO No", id: 3, shortName: "PO#" },
  { name: "Customer Booking No", id: 8, shortName: "CU#" },
  { name: "Product Ref", id: 17, shortName: "PR#" },
  { name: "Report No", id: 17, shortName: "RE#" },
];

export const usertypelist = [
  { name: "Organization", id: 2 },
  { name: "Supplier", id: 3 },
  { name: "Factory", id: 4 },
  { name: "Inspection Company", id: 5 },
  { name: "Laboratory", id: 6 },
  { name: "Label Supplier", id: 8 },
];

export const usertypelistusermanagement = [
  { name: "Organization", id: 2 },
  { name: "Supplier", id: 3 },
  { name: "Factory", id: 4 },
  { name: "Inspection Company", id: 5 },
  { name: "Laboratory", id: 6 },
];

export const usertypelistForCalender = [
  { name: "Organization", id: 2 },
  { name: "Supplier", id: 3 },
  { name: "Factory", id: 4 },
  { name: "Inspection Company", id: 5 },
];

export const msChart = [
  { name: "Yes", id: 1 },
  { name: "No", id: 2 },
];

export const profilelist = [
  { name: "QC", id: 1 },
  // { name: "Qc supervisor", id:2},
  // { name : "Inspector", id:3},
  { name: "Report checker", id: 4 },
];

export const downloadStatusList = [{ name: "Inspected", id: 6 }];

export const defectTypelist = [
  { name: "Major", id: 1 },
  { name: "Minor", id: 2 },
];

export const comparelist = [
  { name: "Last 1 Month", id: 1 },
  { name: "Last 3 Month", id: 3 },
  { name: "Last 6 month", id: 6 },
  { name: "Last 12 month", id: 12 },
];

export const borderLinelist = [
  { name: "N", id: 1 },
  { name: "N+1", id: 2 },
];

export const bookingReportStatusList = [
  { name: "Inspected", id: 6 },
  { name: "Allocated QI", id: 9 },
  { name: "Report Sent", id: 11 },
];

export const reportStatusList = [
  { name: "Scheduled", id: 5 },
  { name: "Inspected", id: 6 },
];

export const SupplierTypes = [
  { name: "Factory", id: 1, userTypeId: 4 },
  { name: "Supplier", id: 2, userTypeId: 3 },
  { name: "InspectionCompany", id: 3, userTypeId: 5 },
  { name: "Laboratory", id: 4, userTypeId: 6 },
  { name: "Agent", id: 5, userTypeId: 8 },
];
export const ProductStatus = [
  { name: "Enabled", id: 1 },
  { name: "Disabled", id: 2 },
];
//Html Element
export enum HtmElement {
  Dropdown = 2,
  MultiSelectDropdown = 3,
}

export enum PurchaseOrderStatus {
  New = 1,
  Preassigned = 2,
  InProgress = 3,
  Completed = 4,
}

export enum Permission {
  Supplier_Summary_List = "Vendor_Management.List",
  Supplier_Summary_Delete = "Vendor_Management.Delete",
  Supplier_Summary_Update = "Vendor_Management.Update",
  Supplier_Summary_View = "Vendor_Management.View",
  summary_List = "summary.List",
  inviteVendor_View = "invite.List",
  inviteVendor_Create = "invite.Create",
  summary_Delete = "summary.Delete",
  summary_Update = "summary.Update",
  summary_View = "summary.View",
  Schedule_List = "Schedule.List",
  Schedule_Delete = "Schedule.Delete",
  Schedule_Update = "Schedule.Update",
  Download_List = "Download.List",
  Download_Delete = "Download.Delete",
  Download_Update = "Download.Update",
  Download_Export = "Download.Export",
  Package_List_List = "Package_List.List",
  Package_List_Delete = "Package_List.Delete",
  Package_List_Update = "Package_List.Update",
  Package_Add_Create = "Package_Add.Create",
  Feature_Add_Create = "Feature_Add.Create",
  Feature_List_List = "Feature_List.List",
  Feature_List_Update = "Feature_List.Update",
  Feature_List_Delete = "Feature_List.Delete",
  Office_Add_Create = "Office_List.Create",
  Office_List_List = "Office_List.List",
  Office_List_Update = "Office_List.Update",
  Office_List_Delete = "Office_List.Delete",
  Right_Add_Create = "Right_Add.Create",
  Role_Add_Create = "Role_Search.Create",
  Permission_Add_Create = "Permission_Add.Create",
  Permission_Search_List = "Permission_Search.List",
  Permission_Search_Delete = "Permission_Search.Delete",
  Permission_Search_Update = "Permission_Search.Update",
  Tenant_Add_Create = "Tenant_Add.Create",
  Tenant_Search_List = "Tenant_Search.List",
  Permission_Map_List = "Permission_Map.List",
  Permission_Map_Delete = "Permission_Map.Delete",
  Permission_Map_Update = "Permission_Map.Update",
  Subscription_List_List = "Subscription_List.List",
  Tenant_Administration_List = "Tenant_Administration.List",
  Tenant_Administration_Create = "Tenant_Administration.Create",
  Tenant_Administration_Delete = "Tenant_Administration.Delete",
  Tenant_Administration_Update = "Tenant_Administration.Update",
  New_Create = "New.Create",
  //Company_Info_Create = "Company_Info.Create",
  Contacts_List = "Contacts.List",
  Contacts_Create = "Contacts.Create",
  Contacts_Delete = "Contacts.Delete",
  Contacts_Update = "Contacts.Update",
  Service_Type__List = "Service_Type.List",
  Service_Type__Create = "Service_Type.Create",
  Service_Type__Delete = "Service_Type.Delete",
  Service_Type__Update = "Service_Type.Update",
  Brand_List = "Brand.List",
  Brand_Create = "Brand.Create",
  Brand_Delete = "Brand.Delete",
  Brand_Update = "Brand.Update",
  Department_List = "Department.List",
  Department_Create = "Department.Create",
  Department_Delete = "Department.Delete",
  Department_Update = "Department.Update",
  New_Subscription_Subscribe = "New_Subscription.Subscribe",
  Booking_List = "booking.List",
  Booking_Delete = "booking.Delete",
  Reinspection_List = "reinpsection.List",
  Rebooking_List = "rebooking.List",
  Role_Search_Delete = "Role_Search.Delete",
  Role_Search_Update = "Role_Search.Update",
  Right_Search_Delete = "Right_Search.Delete",
  Role_Search_List = "Role_Search.List",
  Tenant_Search_Delete = "Tenant_Search.Delete",
  Tenant_Search_Update = "Tenant_Search.Update",
  Organization_Info_List = "Organization_Info.List",
  Organization_Info_Create = "Organization_Info.Create",
  Organization_Info_Delete = "Organization_Info.Delete",
  Organization_Info_Update = "Organization_Info.Update",
  Right_Search_List = "Right_Search.List",
  Right_Search_Update = "Right_Search.Update",
  Filling_and_Review_Export = "Filling_And_Review.Export",
  Filling_and_Review_List = "Filling_And_Review.List",
  Filling_and_Review_SendReport = "Filling_And_Review.InspectionReportSend",
  Defect_List = "Defect.List",
  Defect_Export = "Defect.Export",
  Rejection_List = "Rejection.List",
  Rejection_Export = "Rejection.Export",
  Sub_Category_List = "Sub_Category.List",
  Sub_Category_Create = "Sub_Category.Create",
  Sub_Category_Delete = "Sub_Category.Delete",
  Sub_Category_Update = "Sub_Category.Update",
  Sub_Category_2_List = "Sub_Category_2.List",
  Sub_Category_2_List_Import = "Sub_Category_2.Import",
  Sub_Category_2_Create = "Sub_Category_2.Create",
  Sub_Category_2_Delete = "Sub_Category_2.Delete",
  Sub_Category_2_Update = "Sub_Category_2.Update",
  Category_List = "Category.List",
  Category_Create = "Category.Create",
  Category_Delete = "Category.Delete",
  Category_Update = "Category.Update",
  Purchase_Orders_List = "Purchase_Orders.List",
  Purchase_Orders_Update = "Purchase_Orders.Update",
  Purchase_Orders_Delete = "Purchase_Orders.Delete",
  Purchase_Orders_Create = "Purchase_Orders_New.Create",
  Purchase_Orders_Export = "Purchase_Orders.Export",
  INSP_Summary_List = "INSP_Summary.List",
  INSP_Summary_Update = "INSP_Summary.Update",
  INSP_Summary_Delete = "INSP_Summary.Delete",
  INSP_Summary_Export = "INSP_Summary.Export",
  INSP_Summary_Booking_Reschedule = "INSP_Summary.Inspection_Booking_Reschedule",
  INSP_Summary_Booking_Cancel = "INSP_Summary.Inspection_Booking_Cancel",
  INSP_Summary_Booking_Confirm = "INSP_Summary.Inspection_Booking_Confirmation",

  //INSP_Summary_Booking_Request = "INSP_Summary.Inspection_Booking_Request",

  //INSP_Summary_Booking_Verify = "INSP_Summary.Booking_Verify",
  //INSP_Summary_Quotation_Request = "INSP_Summary.Quotation_Request",

  Audit_Summary_List = "Audit_Summary.List",
  Audit_Summary_Update = "Audit_Summary.Update",
  Audit_Summary_Delete = "Audit_Summary.Delete",
  Audit_Summary_Export = "Audit_Summary.Export",
  Audit_Summary_Cancel = "Audit_Summary.Audit Boooking Cancel",
  Audit_Summary_Reschedule = "Audit_Summary.Reschedule",
  Audit_Report_List = "Audit_Filling_And_Review.List",
  Audit_Booking_Create = "Audit_Booking.Create",
  Audit_Report_Download = "AuditReportDownload.List",
  Change_Password_List = "Change_Password.List",
  Products_List = "Products.List",
  Products_Update = "Products.Update",
  Products_Exports = "Products.Export",
  Products_Delete = "Products.Delete",
  Products_Create = "Product_New.Create",
  Complaint_Create = "COMP_Summary.Create",
  Complaint_Update = "COMP_Summary.Update",
  Complaint_Delete = "COMP_Summary.Delete",
  Complaint_List = "COMP_Summary.List",
  Complaint_Export = "COMP_Summary.Export",
  API_Summary_List = "API_Summary.List",
  API_Summary_Delete = "API_Summary.Delete",
  API_Summary_Update = "API_Summary.Update",
  Register_Api_Create = "Register_Api.Create",
  Register_Api_Update = "Register_Api.Update",
  Permission_List = "Permission.List",
  //BOOKING_Booking_Request = "Booking.Inspection_Booking_Request",
  //BOOKING_Booking_Cancel = "Booking.Inspection_Booking_Cancel",
  //BOOKING_Booking_Reschedule = "Booking.Inspection_Booking_Reschedule",
  INSP_Summary_Booking_Combine = "INSP_Summary.Inspection_Booking_Combine",
  INSP_Summary_Split_Inspection_Booking = "INSP_Summary.Split_Inspection_Booking",
  BOOKING_Split_Inspection_Booking = "Booking.Split_Inspection_Booking",
  UserGuide_List = "User_Guide.List",
  UserProfile_Update = "UserProfile.Update",
  ShipmentRelease_Edit_Shipment_Release = "ShipmentRelease.Edit_Shipment_Release",
  ShipmentRelease_List = "ShipmentRelease.List",
  Booking_Create = "BOOKING.Create",
  Booking_Confirm = "BOOKING.Inspection_Booking_Confirmation",
  Booking_Combine = "BOOKING.Inspection_Booking_Combine",
  Booking_Po_Creation = "BOOKING.Inspection_Booking_Po_Creation",
  Booking_Product_Creation = "BOOKING.Inspection_Booking_Product_Creation",
  Send_Email = "Download.SendIC",
  Season_List = "Season.List",
  Season_Update = "Season.Update",
  Season_Create = "Season.Create",
  Season_Delete = "Season.Delete",
  Qmark_List = "QMark.List",
  ProductAttributes_Create = "ProductAttributes.Create",
  ProductAttributes_List = "ProductAttributes.List",
  ProductAttributes_Update = "ProductAttributes.Update",
  ProductAttributes_View = "ProductAttributes.View",
  ProductBillOfMaterial_Create = "ProductBillOfMaterial.Create",
  ProductBillOfMaterial_Delete = "ProductBillOfMaterial.Delete",
  ProductBillOfMaterial_List = "ProductBillOfMaterial.List",
  ProductBillOfMaterial_Update = "ProductBillOfMaterial.Update",
  ProductBillOfMaterial_View = "ProductBillOfMaterial.View",
  ProductAssociation_View = "ProductAssociation.View",
  Register_Create = "Register.Create",
  Register_Delete = "Register.Delete",
  Register_List = "Register.List",
  Register_Update = "Register.Update",
  ProductDoccument_Create = "ProductDoccument.Create",
  ProductDoccument_Delete = "ProductDoccument.Delete",
  ProductDoccument_List = "ProductDoccument.List",
  ProductDoccument_Export = "ProductDoccument.Export",
  ProductDoccument_View = "ProductDoccument.View",
  productTestingStandard_AddTestSet = "productTestingStandard.AddTestSet",
  productTestingStandard_DeteteTestSet = "productTestingStandard.DeteteTestSet",
  productTestingStandard_Create = "productTestingStandard.Create",
  productTestingStandard_List = "productTestingStandard.List",
  productTestingStandard_Update = "productTestingStandard.Update",
  productTestingStandard_View = "productTestingStandard.View",
  Pim_Product_List = "Pim_Product_Summary.List",
  Pim_Product_Update = "Pim_Product_Summary.Update",
  Pim_Product_Delete = "Pim_Product_Summary.Delete",
  Pim_Product_Upload = "Pim_Product_Summary.Import",
  Pim_Product_Export = "Pim_Product_Summary.Export",
  Data_Access_Summary_List = "AccessData.List",
  Data_Access_Update = "AccessData.Update",
  Data_Access_Delete = "AccessData.Delete",
  PIM_Product_DashBoard_List = "PIM_DashBoard.List",
  PIM_Product_DashBoard_Create_Product = "DashBoard.Create",
  PIM_Product_DashBoard_Export = "DashBoard.Export",

  LAB_TEST_DETAIL_DELETE = "LabTestDetail.Delete",
  LAB_TEST_DETAIL_LIST = "LabTestDetail.List",
  TCF_TEMPLATE_CREATE = "TcfTemplates.Create",
  TCF_TEMPLATE_UPDATE = "TcfTemplates.Update",
  TCF_TEMPLATE_DELETE = "TcfTemplates.Delete",
  TCF_TEMPLATE_LIST = "TcfTemplates.List",
  TCF_DETAIL_UPDATE = "TcfDetail.Update",
  TCF_DETAIL_UPLOAD = "TcfDetail.UplaodDocument",
  TCF_DETAIL_DELETE = "TcfDetail.Delete",
  TCF_DETAIL_DOWNLOAD = "TcfDetail.DownloadDocument",
  TCF_BOOKING_CREATE = "TcfBooking.Create",
  TCF_BOOKING_UPDATE = "TcfBooking.Update",
  TCF_BOOKING_DELETE = "TcfBooking.Delete",
  TCF_BOOKING_LIST = "TcfBooking.List",
  TCF_BOOKING_SUMMARY_LIST = "TcfBookingSummary.List",
  TCF_BOOKING_SUMMARY_UPDATE = "TcfBookingSummary.Update",
  TCF_BOOKING_SUMMARY_EXPORT = "TcfBookingSummary.Export",
  TCF_BOOKING_SUMMARY_DOWNLOAD = "TcfBookingSummary.DownloadDocument",
  TCF_DOCUMENT_SUMMARY_LIST = "TcfDocumentSummary.List",
  TCF_DOCUMENT_SUMMARY_EXPORT = "TcfDocumentSummary.Export",
  TCF_DOCUMENT_SUMMARY_DOWNLOAD = "TcfDocumentSummary.DownloadDocument",
  TCF_CONFIGURATION_LIST = "TcfConfiguration.List",
  TCF_DASHBOARD_LIST = "TcfDashboardNew.List",
  TCF_DASHBOARD_EXPORT = "TcfDashboardNew.Export",
  SUPPLIER_SCORECARD_LIST = "TcfSupplierScoreCard.List",
  SUPPLIER_SCORECARD_EXPORT = "TcfSupplierScoreCard.Export",

  // AUDIT_Factory_Performance_Dashboard = "FactoryPerformance.List",
  // PIM_BOM_Assiciation_View = "PIMBOMASSOCIATION.View",
  // PIM_Product_PO_List = "PIM_Product_PO_Details.List",
  // LAB_TEST_REGULATION_CREATE = "LabTestRegulation_.Create",
  // LAB_TEST_REGULATION_UPDATE = "LabTestRegulation_.Update",
  // LAB_TEST_REGULATION_DELETE = "LabTestRegulation_.Delete",
  AUDIT_Factory_Performance_Dashboard = "FactoryPerformance.List",
  PIM_BOM_Assiciation_View = "PIMBOMASSOCIATION.View",
  PIM_Product_PO_List = "PIM_Product_PO_Details.List",
  LAB_TEST_REGULATION_CREATE = "LabTestRegulation_.Create",
  LAB_TEST_REGULATION_UPDATE = "LabTestRegulation_.Update",
  LAB_TEST_REGULATION_DELETE = "LabTestRegulation_.Delete",
  LAB_TEST_REGULATION_UPLOAD = "LabTestRegulation_.Import",
  LAB_TEST_REGULATION_LIST = "LabTestRegulation_.List",
  LAB_TEST_STANDARD_CREATE = "LabTestStandard.Create",
  LAB_TEST_STANDARD_UPDATE = "LabTestStandard.Update",
  LAB_TEST_STANDARD_DELETE = "LabTestStandard.Delete",
  LAB_TEST_STANDARD_IMPORT = "LabTestStandard.Import",
  LAB_TEST_STANDARD_LIST = "LabTestStandard.List",
  LAB_TEST_DETAIL_CREATE = "LabTestDetail.Create",
  LAB_TEST_DETAIL_UPDATE = "LabTestDetail.Update",

  LAB_TEST_DETAIL_IMPORT = "LabTestDetail.Import",
  LAB_BBOOKING_SUMMARY_LIST = "Lab_Booking_summary.List",
  LAB_BBOOKING_SUMMARY_UPDATE = "Lab_Booking_summary.Update",
  LAB_BBOOKING_SUMMARY_DELETE = "Lab_Booking_summary.Delete",
  LAB_BBOOKING_SUMMARY_SAVE_FILTER = "Lab_Booking_summary.Save_Filter",
  LAB_BBOOKING_SUMMARY_EXPORT = "Lab_Booking_summary.Export",
  LAB_BBOOKING_SUMMARY_DISPLAY_COLUMNS = "Lab_Booking_summary.Display_Columns",
  LAB_BBOOKING_SUMMARY_LAB_DETAIL_PAGE = "Lab_Booking_summary.Lab_Detail_Page",
  LAB_REPORT_EXPORT = "Lab_Report.Export",
  LAB_REPORT_Update = "Lab_Report.Update",
  LAB_REPORT_DOWNLOAD = "Lab_Report.DownloadDocument",
  LAB_REPORT_SAVE_FILTER = "Lab_Report.Save_Filter",
  LAB_REPORT_DISPLAY_COLUMNS = "Lab_Report.Display_Columns",
  LAB_DASHBOARD_EXPORT = "LAB.Export",
  LAB_DASHBOARD_LIST = "LAB.List",
  LAB_REPORT_LAB_DETAIL_PAGE = "Lab_Report.Lab_Detail_Page",
  LAB_RESULT_ANALYTICS = "ResultAnalytics.Export",

  //stage 0ne a permission
  USER_UPDATE = "User.Update",
  USER_VIEW = "User.View",
  USER_SUBMIT = "User.Submit",
  USER_SEND_DOC = "User.SendDocument",

  //stage one b permission
  SUPPLIER_UPDATE = "Supplier.Update",
  SUPPLIER_CREATED = "Supplier.Create",
  SUPPLIER_SUBMITTED = "Supplier.Submit",

  SUPPLIER_SUBMIT = "New.Submit",
  SUPPLIER_VIEW = "New.View",
  SUPPLIER_APPROVED = "New.Approve",
  SUPPLIER_DRAFT = "New.Draft",

  //stage two a
  MANAGER_APPROVE = "Manager.Approve",
  MANAGER_VIEW = "Manager.View",
  PRODUCT_MANAGER_STATUS_VIEW = "Manager.ProductManagerStatus",
  CUSTOMER_MANAGER_STATUS_VIEW = "Manager.CustomerServiceManagerStatus",
  OPERATION_MANAGER_STATUS_VIEW = "Manager.OperationManagerStatus",
  //stage two b
  DOCUMENT_UPDATE = "Document.Update",
  DOCUMENT_VIEW = "Document.View",
  DOCUMENT_APPROVE = "Document.Approve",
  //stage three
  NSOB_VIEW = "NSOB.View",
  NSOB_UPDATE = "NSOB.Update",
  //stage four
  CHECKLIST_VIEW = "CheckList.View",
  CHECKLIST_UPDATE = "CheckList.Update",
  //stage five
  PRODUCT_VIEW = "ProductManagement.View",
  PRODUCT_UPDATE = "ProductManagement.Update",
  //stage six
  SIGNOFF_VIEW = "SignOff.View",
  SIGNOFF_UPDATE = "SignOff.Update",
  //stage seven
  LAUNCH_CREATE = "Launch.Create",
  LAUNCH_UPDATE = "Launch.Update",
  LAUNCH_VIEW = "Launch.View",
  LAUNCH_SUBMIT = "Launch.Submit",

  //Brand-Approval
  SUPPLIER_PRODUCT_APPROVAL = "Supplier-Product-Approval.TechApproval",
  SUPPLIER_PRODUCT_APPROVAL_TECH_MANGER_APPROVAL = "Supplier-Product-Approval.TechManagerApproval",
  SUPPLIER_PRODUCT_APPROVAL_VIEW = "Supplier-Product-Approval.View",

  //Supplierlist
  SUPPLIER_MANAGEMENT_LIST = "SupplierManagement.List",
  SUPPLIER_MANAGEMENT_CREATE = "SupplierManagement.Create",
  SUPPLIER_MANAGEMENT_DELETE = "SupplierManagement.Delete",
  SUPPLIER_MANAGEMENT_UPDATE = "SupplierManagement.Update",

  //modelcodeList
  SUPPLIER_MODEL_CODE_LIST = "Supplier-ModelCode.List",

  //route level permission
  SUPPLIER_INVITATION = "Supplier-Invite.View",
  SUPPLIER_MANAGEMENT = "Vendor_Management.View",
  LABLE_SUPPLIER_UPDATE = "Vendor_Management.Update",
  SUPPLIER_PRODUCT_APPROVE = "Supplier-Product-Approval.View",
  SUPPLIER_PRODUCT_TECHAPPROVE = "Supplier-Product-Approval.TechApproval",
  SUPPLIER_PRODUCT_TECH_MANGER_APPROVE = "Supplier-Product-Approval.TechManagerApproval",

  LAB_RESULT_ANALYTICS_LIST = "ResultAnalytics.List",

  Material_List = "Material.List",
  Material_Create = "Material.Create",
  Material_Delete = "Material.Delete",
  Material_Update = "Material.Update",
  Material_Download = "Material.DownloadDocument",
  Material_Import = "Material.Import",
  Material_Group_Create = "Material_Group.Create",
  Material_Group_Delete = "Material_Group.Delete",
  Material_Group_Update = "Material_Group.Update",
  Material_SubGroup_List = "Material_SubGroup.List",
  Material_SubGroup_Create = "Material_SubGroup.Create",
  Material_SubGroup_Delete = "Material_SubGroup.Delete",
  Material_SubGroup_Update = "Material_SubGroup.Update",

  // PLM Permisssion
  //Create Design
  CREATE_DESIGN_APPROVE = "CreateDesign.Approve", //buyer
  CREATE_DESIGN = "CreateDesign.Create", //supplier
  SUBMIT_DESIGN = "CreateDesign.Submit", //tech
  SAVE_DESIGN = "CreateDesign.View",//only save button


  // Care wording
  Create_Care_Wording = "PLMCareWording.Create",
  Approve_Care_Wording = "PLMCareWording.Approve",
  Submit_Care_Wording = "PLMCareWording.Submit",
  VIEW_CARE_WORDING = "PLMCareWording.View",

  //Sample review
  Approve_Reject_Sample_review = "SampleReview.Approve", //buyer
  Submit_sample_review = "SampleReview.Submit", //tech
  Sample_review_update = "SampleReview.Update", //supplier
  Sample_review_view = "SampleReview.View", //supplier

  BlackSeal_Approve = "BlackSeal.Approve",//Tech
  BlackSeal_Create = "BlackSeal.Create",
  BlackSeal_View = "BlackSeal.View",
  BlackSeal_Update = "BlackSeal.Update",
  BlackSeal_Submit = "BlackSeal.Submit",

  goldSeal_Create = "goldSeal.Create",
  goldSeal_View = "goldSeal.View",
  goldSeal_Submit = "goldSeal.Submit",
  goldSeal_Approve = "goldSeal.Approve",
  goldSeal_Update = "goldSeal.Update",


  //DIGI EYE
  CREATE_DIGI_EYE = "DigiEye.Create", //supplier create
  APPROVE_DIGI_EYE = "DigiEye.Approve", //buyer approve
  APPROVE_AND_SUBMIT_DIGI_EYE = "DigiEye.Update", //tech submit and Approve
  VIEW_DIGI_EYE = "DigiEye.View",

  // digieyeLabPermision
  CREATE_LAB_DIGI_EYE = "labview.Create", //supplier create
  VIEW_LIST_DIGI_EYE = "labview.List", //buyer approve
  SUBMIT_DIGI_EYE = "labview.Submit", //labuser submit lab images

  Criteria_Dashboard_List = "Criteria_Dashboard.List",
  FABRIC_DASHBOARD_LIST = "FABRICEVALUATION_.List",
  LAB_TEST_SUMMARY_LIST = "labtestsummary_report.List",
  AUDIT_DASHBOARD_LIST = "AuditDashboard.List",
  LAB_BOOKING_SUMMARY_LIST = "Lab_Booking_Trans.List",
  EMAIL_NOTIFICATION_LIST = "EmailConfiguration.List",
  LANDING_ANALYTICAS_LIST = "Landing_Analytics.List",
  AUDIT_CALENDAR_AUDIT = "Audit_Calender.List",
  INSPECTION_CALENDAR_LIST = "Calender.List",
  Purchase_Order_Upload_List = "UploadPo.List",
  Custom_KPI_List = "KPI.List",
  Factory_DASHBOARD_LIST = "Factory.List",
  INSPECTOR_DASHBOARD_LIST = "INSPECTOR.List",
  LAB_REPORT_List = "Lab_Report.list",
  PRODUCT_DASHBOARD_LIST = "Product_DashBoard.List",
  SUPPLIER_LIST = "Supplier_Summary.List",
  Vendor_OverView_List = "vendor_OverView.List",
  MILL_RISK_DASHBOARD_List = "MillAuditDashboard.List",
  MILL_RISK_DASHBOARD_EXPORT = "MillAuditDashboard.Export",
  TestCategory_List = "TestCategory.List",
  TestCategory_Update = "TestCategory.Update",
  TestCategory_Create = "TestCategory.Create",
  TestCategory_Delete = "TestCategory.Delete",
  TestCategoryDashboard_List = "TestCategoryDashboard.List",
  TestCategoryDashboard_Export = "TestCategoryDashboard.Export",
  LAB_TEST_VIEW_CUSTOMER_DECISION = "labtestsummary_report.ViewLabCustomerDecision",
  LAB_TEST_EDIT_CUSTOMER_DECISION = "labtestsummary_report.EditLabCustomerDecision",

  // digieyeLabPermision
  // CREATE_LAB_DIGI_EYE = "labview.Create",//supplier
  // VIEW_LIST_DIGI_EYE = "labview.List", //buyer
  // SUBMIT_DIGI_EYE = "labview.Submit",//labuser

  LAB_PASS_RATE_TRENDS_LIST = "LabPassRateDashboard.List",
  // LAB_PASS_RATE_TRENDS_EXPORT = "LabPassRateDashboard.Export",
  // LAB_NEW_BOOKING_EXPORT = "Lab_Booking_Trans.Export",
  // LAB_NEW_BOOKING_DISPLAY_COLUMNS = "Lab_Booking_Trans.Display_Columns",
  // LAB_NEW_BOOKING_SAVE_FILTER = "Lab_Booking_Trans.Save_Filter",
  // PIM_SUMMARY_DISPLAY_COLUMNS = "Pim_Product_Summary.Display_Columns",
  // PIM_SUMMARY_SAVE_FILTER = "Pim_Product_Summary.Save_Filter",

  // PIM_SUMMARY_EXPORT = "Pim_Product_Summary.Export",
  // RESET_CACHE_DELETE = "Reset_Cache.Delete",

  // PIF Permission
  SUBMIT_PIF = "PIF.Submit", //tech both approve and submit
  CREATE_PIF = "PIF.Create", //supplier only create
  APPROVE_PIF = "PIF.Approve", //buyer only approve with undo button
  VIEW_PIF = "PIF.View",

  // critical path
  CREATE_CRITICAL_PATH = "PLMCriticalPath.Create",
  APPROVE_CRITICAL_PATH = "PLMCriticalPath.Approve",
  SUBMIT_CRITICAL_PATH = "PLMCriticalPath.Submit",
  VIEW_CRITICAL_PATH = "PLMCriticalPath.View",

  // Technical  path
  CREATE_TECHNICAL_DRAWING_PATH = "TechnicalDrawing.Create",
  APPROVE_TECHNICAL_DRAWING_PATH = "TechnicalDrawing.Approve",
  SUBMIT_TECHNICAL_DRAWING_PATH = "TechnicalDrawing.Submit",
  VIEW_TECHNICAL_DRAWING_PATH = "TechnicalDrawing.View",

  // BOM  path
  CREATE_BOM = "BillOfMaterial.Create",
  APPROVE_BOM = "BillOfMaterial.Approve",
  SUBMIT_BOM = "BillOfMaterial.Submit",
  VIEW_BOM = "BillOfMaterial.View",

  //Package specification
  CREATE_PACKAGE_SPECIFICATION = "PackageSpecification.Create",
  APPROVE_PACKAGE_SPECIFICATION = "PackageSpecification.Approve",
  SUBMIT_PACKAGE_SPECIFICATION = "PackageSpecification.Submit",
  VIEW_PACKAGE_SPECIFICATION = "PackageSpecification.View",

  //fabric specification
  CREATE_FABRIC_SPECIFICATION = "FabricSpecification.Create",
  APPROVE_FABRIC_SPECIFICATION = "FabricSpecification.Approve",
  SUBMIT_FABRIC_SPECIFICATION = "FabricSpecification.Submit",
  VIEW_FABRIC_SPECIFICATION = "FabricSpecification.View",
  //Product Development
  Approve_Reject_Product_development = "ProductDevelopment.Approve", //buyer
  Submit_product_development = "ProductDevelopment.Submit", //tech
  Update_Product_Development = "ProductDevelopment.Update", //supplier
  VIEW_PRODUCT_DEVELOPMET = "ProductDevelopment.View",

  //Minimum Test Standard
  MinimumTestStd_Create = "MinimumTestStd.Create",
  MinimumTestStd_View = "MinimumTestStd.View",
  MinimumTestStd_Delete = "MinimumTestStd.Delete",
  MinimumTestStd_Approve = "MinimumTestStd.Approve",

  // Notification
  NOTIFICATION_SHOW = "Notification_Settings.Create",

  // IntialTesting
  SUBMIT_INTIAL_TESTING = "InitialTesting.Update", //submit and Approve booking
  APPROVE_INITIAL_TESTING = "InitialTesting.Approve", //approve/reject/undo
  UPDATE_INITAL_TESTING = "InitialTesting.Update", //update lab test result
  CREATE_INITIAL_TESTING = "InitialTesting.Create", //book lab test
  VIEW_INTIAL_TESTING = "InitialTesting.View",

  BULK_TESTING_UPDATE = "BulkTesting.Update",
  BULK_TESTING_APPROVE = "BulkTesting.Approve",
  BULK_TESTING_CREATE = "BulkTesting.Create",
  VIEW_BULK_TESTING = "BulkTesting.View",


  // Risk Assesment
  CREATE_RISK = "RiskAssessment.Create",
  APPROVE_RISK = "RiskAssessment.Approve", //approve/reject/undo
  //Notification_preference
  NOTIFICATION_PREFERENCE_CREATE = "NotificationPreferences.Create",
  LAB_NEW_BOOKING_EXPORT = "Lab_Booking_Trans.Export",
  LAB_NEW_BOOKING_DISPLAY_COLUMNS = "Lab_Booking_Trans.Display_Columns",
  LAB_NEW_BOOKING_SAVE_FILTER = "Lab_Booking_Trans.Save_Filter",
  PIM_SUMMARY_DISPLAY_COLUMNS = "Pim_Product_Summary.Display_Columns",
  PIM_SUMMARY_SAVE_FILTER = "Pim_Product_Summary.Save_Filter",
  PIM_SUMMARY_EXPORT = "Pim_Product_Summary.Export",
  RESET_CACHE_DELETE = "Reset_Cache.Delete",
  LAB_PASS_RATE_TRENDS_EXPORT = "LabPassRateDashboard.Export",
  Measurement_Upload_LIST = "Measurement_Upload.List",
  RISK_SCORE_CARD_LIST = "Risk_Score_Card.List",
  RISK_SCORE_CARD_EXPORT = "Risk_Score_Card.Export",
  RISK_SCORE_CARD_DASHBOARD_LIST = "Risk_Score_Card_DashBoard.List",
  RISK_SCORE_CARD_DASHBOARD_EXPORT = "Risk_Score_Card_DashBoard.Export",
  Qc_Availability_Summary_LIST = "Qc_availability_Summary.List",
  Qc_Availability_Summary_ADD = "Qc_availability_Summary.Create",
  Qc_Availability_Summary_UPDATE = "Qc_availability_Summary.Update",
  Qc_Availability_Summary_DELETE = "Qc_availability_Summary.Delete",
  PARTNER_CONFIG_LIST = "Partner_Configuration.List",
  PARTNER_API_CONFIG_DELETE = "Partner_Api_Config.Delete",
  PARTNER_API_CONFIG_UPDATE = "Partner_Api_Config.Update",
  PARTNER_API_CONFIG_CREATE = "Partner_Api_Config.Create",
  PARTNER_API_CONFIG_LIST = "Partner_Api_Config.List",
  PARTNER_API_CONFIG_VIEW = "Partner_Api_Config.View",
  PARTNER_AUTH_CONFIG_DELETE = "Partner_Auth_Config.Delete",
  PARTNER_AUTH_CONFIG_UPDATE = "Partner_Auth_Config.Update",
  PARTNER_AUTH_CONFIG_CREATE = "Partner_Auth_Config.Create",
  PARTNER_AUTH_CONFIG_LIST = "Partner_Auth_Config.List",
  PARTNER_AUTH_CONFIG_VIEW = "Partner_Auth_Config.View",
  SERVICE_EVENT_TYPE_MAP_DELETE = "Service_EVent_Type_Map.Delete",
  SERVICE_EVENT_TYPE_MAP_UPDATE = "Service_EVent_Type_Map.Update",
  SERVICE_EVENT_TYPE_MAP_CREATE = "Service_EVent_Type_Map.Create",
  SERVICE_EVENT_TYPE_MAP_LIST = "Service_EVent_Type_Map.List",
  SERVICE_EVENT_TYPE_MAP_VIEW = "Service_EVent_Type_Map.View",
  Risk_Analysis_Configuration_Summary_Create = "Risk_Analysis_Configuration_Summary.Create",
  Risk_Analysis_Setting_List = "Risk_Analysis_Setting.List",
  LAB_BOOKING_SYNC_LIST = "lab_booking_sync.List",
  LAB_BOOKING_SYN_CREATE = "lab_booking_sync.Create",
  QUOTATION_SUMMARY_LIST = "quotation-summary.List",
  QUOTATION_SUMMARY_EXPORT = "quotation-summary.Export",
  INVOICE_SUMMARY_LIST = "Invoice_Summary.List",
  Performance_SUMAARY_LIST = "Performance_Analytics.LIST",
  INVITATIONSTATUS_LIST = "Invitation_Status.List",
  INVOICE_SUMMARY_EXPORT = "Invoice_Summary.Export",

  PIP_CREATE = "PIPUpdate.Create", //BUYer
  PIP_SUBMIT = "PIPUpdate.Update", //tech
  PIP_APPROVE = "PIPUpdate.View", //supplier

  DIGIN_BRIDGE_EXPORT = "productlifecyclelanding.Export", //supplier
  NEW_SUBMIT = "New.Submit",
  NEW_APPROVE = "New.Approve",
  NEW_DRAFT = "New.Draft",
}

export enum InspectionBookingOption {
  Save = 1,
  Edit = 2,
  Confirm = 3,
  Cancel = 4,
  Reschedule = 5,
  Combine = 6,
  SplitBooking = 7,
}

export enum ImportFileType {
  Add = 1,
  Update = 2,
  Both = 3,
}

export enum FileExtension {
  JPEG = "JPG",
  PDF = "PDF",
  XLSX = "XLSX",
  DOC = "DOCX",
}

export const DB_Table_Name = [
  {
    name: "contact",
    tableName: "CU_Contact",
    mainTable: "CU_Contact",
    referenceTableName: "",
    dropdown: [{ name: "Email" }],
  },
  {
    name: "vendor",
    tableName: "SU_Supplier,SU_Address",
    mainTable: "SU_Supplier",
    referenceTableName: "SU_Address",
    dropdown: [{ name: "Email" }],
  },
  { name: "purchaseorder", tableName: "CU_Products" },
  {
    name: "vendor-contact",
    tableName: "SU_Contact,SU_Contact_API_Services",
    mainTable: "SU_Contact",
    referenceTableName: "SU_Contact_API_Services",
    dropdown: [{ name: "Mail" }],
  },
];

export enum ComplaintStatus {
  New = 1,
  Analyzed = 2,
  Approved = 3,
  Rejected = 4,
  Closed = 5,
  Cancelled = 6,
}

export enum ComplaintRefCategory {
  Complaint = 3,
  Analyze = 4,
}

export const ComplaintFileCategory = [
  { name: "Complaint", id: 3, isDisabled: false },
  { name: "Analyze", id: 4, isDisabled: false },
];

export const comparisonMonths = [
  { name: "Last 1 Month", id: "-1", customtext: "past 1 month" },
  { name: "Last 3 Month", id: "-3", customtext: "past 3 month" },
  { name: "Last 6 Month", id: "-6", customtext: "past 6 month" },
  { name: "Last 12 Month", id: "-12", customtext: "past 12 month" },
];

export const comparisonFactoryMonths = [
  { name: "Last 1 Month", id: "-1", customtext: "past 1 month" },
  { name: "Last 3 Month", id: "-3", customtext: "past 3 month" },
  { name: "Last 6 Month", id: "-6", customtext: "past 6 month" },
  { name: "Last 12 Month", id: "-12", customtext: "past 12 month" },
];

export const DateType = [
  { name: "DD-MM-YYYY", id: 1, dbFormate: "dmy" },
  { name: "MM-DD-YYYY", id: 2, dbFormate: "mdy" },
  { name: "YYYY-MM-DD", id: 3, dbFormate: "ymd" },
];

export enum MethodType {
  GET = 1,
  POST = 2,
  PUT = 3,
  DELETE = 4,
}
export enum CustomSampleSizeResult {
  Success = 1,
  CannotGetList = 2,
  Failed = 3,
}
export enum DfCustomerConfigurationListResult {
  Success = 1,
  NotFound = 2,
}
export enum ReInspectionTypeResult {
  Success = 1,
  NotFound = 2,
}
export enum CustomerServiceTypeResult {
  Success = 1,
  CannotGetServiceTypeList = 2,
}
export enum BookingRuleResult {
  Success = 1,
  BookingRuleNotFound = 2,
}

export enum KPIECIRResponseResult {
  Success = 1,
  RowsDataNotMoreThan50000 = 2,
  SheetNotFound = 3,
}

export const DownloadMenu = [
  {
    menu: [
      {
        label: "Image",
        menu: [
          { type: "png", label: "PNG" },
          { type: "jpg", label: "JPG" },
          { type: "svg", label: "SVG" },
          { type: "pdf", label: "PDF" },
        ],
      },
      {
        label: "Print",
        type: "print",
      },
    ],
  },
];

export const containerHeightForMobileChartPopup: number = 400;
export const containerHeightForNotMobileChartPopup: number = 300;
export const containerHeightForLargeChartPopUp: number = 500;

export enum CustomTable {
  VendorSummary = 1,
  InspectionSummary = 2,
  FillingAndReview = 3,
  ReportDownload = 4,
  ShipmentRelease = 5,
  PurchaseOrderSummary = 6,
  AuditSummary = 7,
  ProductReferenceSummary = 8,
  AuditFillingAndReview = 9,
  PimProductSummary = 10,
  QmarkDashboardSummary = 11,
  EmailNotification = 12,
  TcfBookingSummary = 13,
  LabBookingSummary = 14,
  LabReportSummary = 15,
  NewLabBooking = 16,
  AuditReportDownload = 17,
  labBookingSync = 18,
  QuotationPage = 19,
  InvoiceSummary = 20,
  NewEfiling = 21,
  NewTcfBooking = 22,
  EFilingSummary = 23,
  PLMComponentAssociation = 25,
  PLMDashboard = 24,
  PLMComponentFabricDashboard = 25,
}

export enum UserRoleType {
  QCCompany = 1,
  General = 3,
  Admin = 5,
  Vendor = 8,
}
export const ProdtuctRecordTab = [
  { state: 1, isDisplay: "tab1", name: "Attributes" },
  { state: 2, isDisplay: "tab2", name: "Bill Of Materials" },
  { state: 3, isDisplay: "tab4", name: "Testing Standard" },
  { state: 4, isDisplay: "tab5", name: "Documents" },
  { state: 5, isDisplay: "tab6", name: "PO" },
  { state: 6, isDisplay: "tab3", name: "Association" },
  { state: 7, isDisplay: "tab7", name: "Measurement" },
];
export const PimProductStatus = [
  { name: "Deative", id: 0 },
  { name: "Active", id: 1 },
];

export const PimProductSearchtypelst = [
  { name: "Product Reference", id: 1, shortName: "PR#" },
  { name: "Product Description", id: 2, shortName: "PD#" },
  { name: "Barcode", id: 3, shortName: "BR#" },
  { name: "Vendor Product Reference", id: 4, shortName: "VP#" },
];

export const PlmDesignSearchtypelst = [
  { name: "Year", id: 1, shortName: "YE#" },
  { name: "Season", id: 2, shortName: "SE#" },
  { name: "Launch pahse", id: 3, shortName: "LP#" },
  { name: "Department", id: 4, shortName: "DE#" },
  { name: "Product Group", id: 4, shortName: "PG#" },
  { name: "Product SubGroup", id: 4, shortName: "PS#" },
  { name: "PLM Tab", id: 4, shortName: "PT#" },
  { name: "Design Brief", id: 4, shortName: "DB#" },
];

export enum PFREFPages {
  ProductionSummary = 1,
  InspectionSummary = 2,
  ReportDownload = 3,
  ReportFilling = 4,
  ShipmentRelease = 5,
  AuditSummary = 6,
  AuditReportFilling = 7,
  DefectDashboard = 8,
  RejectDashboard = 9,
  FactoryDashboard = 10,
  ProductDashboard = 11,
  InspectorDashboard = 12,
  TenantDashboard = 13,
  AuditDashboard = 14,
  PimProductDashBoard = 15,
  TcfBookingSummary = 16,
  TcfDocumentSummary = 17,
  TcfDashboard = 18,
  SupplierScorecard = 19,
  LabDashboard = 20,
  LabBookingSummery = 21,
  LabBookingReportSummery = 22,
  MillRiskSummary = 23,
  FabricDashboard = 24,
  AuditReportDownload = 25,
  RiskScoreCard = 26,
  LAbBookingSync = 27,
  QuotationPage = 28,
  InvoiceSummary = 29,
}

export enum PFREFDateFilter {
  Last30Days = 1,
  Last15Days = 2,
  PlusMinus3Days = 3,
  YTD = 4,
  MTD = 5,
  Custom = 6,
  Next30Days = 7,
  Next60Days = 8,
  Last3Months = 9,
  Last6Months = 10,
  Oneyear = 11,
  Last10Days = 12,
}
export enum DefaultStandardDateType {
  StartDate = 1,
}

export const FbReportSyncType = [
  { name: "Pass", id: 2 },
  { name: "Fail", id: 3 },
];

export const ServiceType = [
  { name: "Inspection", id: 1 },
  { name: "Audit", id: 2 },
];
export const regulationdatetypelst = [
  { name: "Inforce Date", id: 1 },
  { name: "Discard Date", id: 2 },
];
export const standarddatetypelst = [
  { name: "Start Date", id: 1 },
  { name: "Expiry Date", id: 2 },
  { name: "Discard Date", id: 3 },
];
export const labTestCurrentList = [
  { name: "Yes", id: true },
  { name: "No", id: false },
];

export enum DefaultRegulationDateType {
  InforceDate = 1,
}

export enum SaveResponseResult {
  Success = 1,
  NotSaved = 2,
  NotExist = 3,
  EmptyRequest = 4,
}

export enum DeleteResponseResult {
  Success = 1,
  NotDeleted = 2,
  NotFound = 3,
}

export enum TCFTemplateStatus {
  New = 1,
  Pending = 2,
  InProgress = 3,
  DocReady = 4,
  ToBeFinalized = 5,
  Completed = 6,
}

export const tcfScopeBoolValues = [
  { name: "Yes", id: true },
  { name: "No", id: false },
];

export const tcfScopeReqAsPerProject = [
  { name: "Same As Template", id: true },
  { name: "Defined below", id: false },
];

export const supplierTypeList = [
  { name: "Supplier Name", id: 13 },
  { name: "Supplier Code", id: 14 },
];

export const zeroPrefixValue = 10;

export const firstvalue = 1;

export const tcfSearchtypelstNew = [
  { name: "Barcode", id: 1, shortName: "BR#" },
  { name: "Customer Reference", id: 2, shortName: "CR#" },
  { name: "Po No", id: 3, shortName: "PO#" },
  { name: "TCF No", id: 4, shortName: "TCF#" },
  { name: "Supplier Reference", id: 5, shortName: "SR#" },
  { name: "Description", id: 6, shortName: "DE#" },
];

export const TCFTermList = [
  { id: 1, name: "1 Year" },
  { id: 2, name: "6 Month" },
  { id: 3, name: "3 Month" },
  { id: 5, name: "Custom" },
];

export const DataLengthTrim: number = 5;

export enum TCFScoreCardSort {
  Supplier = 1,
  TCFCompleted = 2,
  TCFToBeFinalized = 3,
  TCFInProgress = 4,
  TCFNew = 5,
  DocsSubmitted = 6,
  DocsWaiting = 7,
}

export enum TCFScoreCardSortedBy {
  Asc = 1,
  Desc = 2,
}
export const topSupplier = [
  {
    id: 5,
    type: 5,
  },
  {
    id: 10,
    type: 10,
  },
  {
    id: 25,
    type: 25,
  },
];

export const Desc = "desc";
export const Asc = "asc";

export const topTestCategory = [
  {
    id: 5,
    type: 5,
  },
  {
    id: 10,
    type: 10,
  },
  {
    id: 15,
    type: 15,
  },
  {
    id: 25,
    type: 20,
  },
  {
    id: 25,
    type: 25,
  },
];

export const TcfUsertypelist = [
  { name: "Organization", id: 2 },
  { name: "Third Party", id: 5 },
];

export const labBookingSearchTypelst = [
  { name: "Booking No", id: 1, shortName: "LB#" },
  { name: "PO No", id: 3, shortName: "PO#" },

  { name: "Product Reference No.", id: 17, shortName: "PR#" },
];
export const labBookingSyncSearchTypelst = [
  { name: "Booking No", id: 1, shortName: "LB#" },
];
export enum CustomTableForlog {
  inspectionBooking = 1,
  AuditBooking = 2,
  Product = 3,
  Purchaseorder = 4,
  Supplier = 5,
  ShipmentRelease = 9,
  ProductCategory = 10,
  ProductSubCategory = 11,
  ProductSubCategory2 = 12,
  tcfBooking = 6,
  tcfDetail = 7,
  PurchaseOrders = 8,
  LabBooking = 13,
  LabReport = 14,
  SampleReview = 15,
  CriticalPath = 16,
  BillOfMaterial = 17,
  CareSymbolAndWording = 18,
  DigiEyeImage = 19,
  ProductInfoForm = 20,
  TechnicalDrawing = 21,
  RiskAssesment = 22,
  ProductDevelopment = 23,
}
export const labBookingdatetypelst = [
  { name: "Reception date", id: 18 },
  { name: "Due date", id: 19 },
  { name: "Issue date", id: 20 },
];

export const labBookingSummarydatetypelst = [
  { name: "Apply date", id: 5 },
  { name: "Due date", id: 19 },
  { name: "Reception date", id: 18 },
];

export enum LabReportTypes {
  generateReport = 1,
  oCR = 2,
  manual = 3,
}

export const LabReportStatusForddl = [
  { name: "Pass", id: 1 },
  { name: "Fail", id: 2 },
  { name: "See Data", id: 3 },
];
export const DateFilterTypes = [
  { name: "Month", id: "Month" },
  { name: "Week", id: "Week" },
  { name: "Day", id: "Day" },
];

export enum ResetPasswordResult {
  Success = 1,
  PasswordNotSaved = 2,
  CurrentPasswordNotMatch = 3,
  PasswordNotMatch = 4,
  InvalidPassword = 5,
  UserIdNotExist = 6,
  MatchedWithPreviousPassword = 7,
}

export enum ChangesPasswordResult {
  Success = 1,
  PasswordNotSaved = 2,
  CurrentPasswordNotMatch = 3,
  PasswordNotMatch = 4,
  InvalidPassword = 5,
  MatchedWithPreviousPassword = 6,
}
export enum ScoreCardType {
  Factory = 1,
  Supplier = 2,
}

export enum AllocationStatus {
  Available = 1,
  Allocated = 2,
  NotAvailable = 3,
}

export const ParnterConfigurationTab = [
  { state: 1, isDisplay: "tab1", name: "Event Type Map" },
  { state: 2, isDisplay: "tab2", name: "Auth Config" },
  { state: 3, isDisplay: "tab4", name: "Api Config" },
];
export enum PartnerSyncStatus {
  Pending = 1,
  Success = 2,
  Failed = 3,
}

export enum QuotationNewStatus {
  Pending = 0,
  Created = 1,
  ManagerApproved = 2,
  ManagerRejected = 3,
  Verified = 4,
  Canceled = 5,
  CustomerRejected = 6,
  CustomerValidated = 7,
  SentToClient = 8,
  AERejected = 9,
}
